import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { GlobalsService } from 'app/globals-services/globals.service';
import { BrandFactoryConnectionService } from 'app/shared/services/brand-factory-connection.service';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';



@Component({
  selector: 'app-connection-factory',
  templateUrl: './connection-factory.component.html',
  styleUrls: ['./connection-factory.component.scss']
})
export class ConnectionFactoryComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'Company Name',
    // 'Role', 
    // 'Supplier ID', 
    // 'Walmart Mill ID',
    'countryName',
    'Date Of Request',
    'Connection Status'
  ];
  searchResultDisplayedColumns: string[] = [
    'Company Name',
    // 'Role', 
    // 'Supplier ID', 
    // 'Walmart Mill ID',
    // 'Date Of Request',
    'countryName',
    'Connection Status'
  ];

  bulkExistingMatchDisplayedColumns: string[] = [
    'Company Name',
    'matchType',
    'databaseMatch',
    'Connect'
  ];

  row: any;

  // suppliers: any[] = [];
  searchResultList: any[] = [];
  totalCount: any = 0;
  page: number = 0;
  pageSize: number = 10;

  localSupplierList: any = [];
  supplierList: any = [];
  inputText: string;

  isCheckMatchPatners: Boolean;
  subscription: Subscription;

  // dataSource: MatTableDataSource<any> = null;
  // searchDataSource: MatTableDataSource<any> = null;
  uploadFactoryListDataSource: MatTableDataSource<any> = null;

  matchedAllSelect = false;
  nonMatchedAllSelect = false;
  isSearching: boolean = false;

  // dataFmList: any;
  document: any;

  // Child & Parent Tab Content Display Variable 
  childTabDisplay = 0;
  MngExstingTab: boolean = true;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('nonFoundFmSort', { static: true }) nonFoundFmSort: MatSort;

  @ViewChild('fileUploadVariable') fileUploadVariable: ElementRef;
  matchResultList: any;
  statusFilter: number = -1;

  alertMsgs = {}

  constructor(
    private brandFactoryConnectionService: BrandFactoryConnectionService,
    private globalServices: GlobalsService,
    private toastService: ToastService,
    private translateService: TranslateService
    //  private dialog: MatDialog,
  ) {

    this.subscription = this.control.valueChanges
      .pipe(
        debounceTime(700),
        distinctUntilChanged()
      )
      .subscribe(value => {
        if (value && value.length > 0) {
          this.globalServices.showSpinner();

          this.searchFormulaByKeyword(value, this.row);
          this.globalServices.hideSpinner();
        }

      });

  }

  ngOnInit(): void {

    // this.countBrandConnectionRequest()

    this.fetchTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.fetchTranslations();
    });

  }

  ngAfterViewInit() {
  }

  fetchTranslations() {
    this.translateService
      .get('BRAND_FACTORY_CONNECTION_COMPONENT.MESSAGES')
      .subscribe((response) => {
        this.alertMsgs = response;
      });
  }

  // @ Parent Tab Change Event Method
  onTabChanged(index) {
    switch (index) {
      case 0:
        this.isCheckMatchPatners = false;
        this.MngExstingTab = true;
        //  this.countBrandConnectionRequest()
        break;
      case 1:
        this.childTabDisplay = 0;
        this.MngExstingTab = false;
        break;
    }
  }

  onChildTabChanged(index) {
    switch (index) {
      case 0:
        this.childTabDisplay = 0;
        this.isCheckMatchPatners = false;
        break;
      case 1:
        // this.getSharedSuppliers();
        this.childTabDisplay = 1;
        break;
    }

  }



  /**
   *  @ Match Existing Partner Contacts From Excel File
   */
  matchExistingPartnerContact() {
    this.isCheckMatchPatners = true;
  }

  // @ Bulk Existing Partner Selection All
  control = new FormControl('');

  onCheckedAll(checked, dataSource) {
    if (checked) {
      dataSource.data.forEach(r => {
        //  if (!r.isAlreadyConnected && r.requestTo != undefined)
        if (!r.isAlreadyConnected)
          r.checked = true;
      }
      )
    } else {
      dataSource.data.forEach(r => {
        r.checked = false;
      })
    }

  }

  removeMatching(row) {

    if (this.row && this.row.requestTo == row.requestTo) {
      return;
    }



    this.uploadFactoryListDataSource['data'].forEach(element => {
      element.isActiveRow = false;
    });

    row.isActiveRow = true;

    this.row = row

    //if already search result available dont process further
    if (row.searches == null || row.searches.length == 0) {
      this.searchFactoryByName(row)
      return;
    }

  }

  searchFactoryByName(row) {
    let data = {
      searchString: row.requestToName,
      requestFrom: this.globalServices.profile['id']
    };

    this.globalServices.showSpinner();
    this.brandFactoryConnectionService.searchFactoryByList(data).subscribe((response: any) => {
      row.searches = response;
      this.globalServices.hideSpinner();

    }, (err) => {
      this.globalServices.hideSpinner();
    });
  }

  searchFormulaByKeyword(Keyword, row) {
    let data = {
      searchString: Keyword,
      requestFrom: this.globalServices.profile['id']
    };

    this.globalServices.showSpinner();
    this.brandFactoryConnectionService.searchFactoryByList(data).subscribe((response: any) => {
      this.globalServices.hideSpinner();
      row.searches = response;
      this.isSearching = false;
    }, (err) => {
      this.globalServices.hideSpinner();
    });
  }

  onMatchClick(row, option) {
    this.control.setValue('')
    // this.globalServices.showSpinner();
    row.matchedSupplierName = option.name
    row.requestToName = option.name
    row.requestTo = option.id

    // this.globalServices.hideSpinner();


  }

  addFile(files: FileList) {

    let file: File = files[0];
    let uploadTypes = ['xlsx'];

    let nameArray = file.name.split('.');
    let type = nameArray[nameArray.length - 1];

    if (uploadTypes.includes(type)) {
      this.document = file
    } else {
      this.toastService.error(this.alertMsgs['INCORRECT_FILE_UPLOAD_ALERT'])
    };

  }

  upload() {

    if (this.document == null) {

      this.toastService.warn(this.alertMsgs['EMPTY_FILE_UPLOAD_ALERT'])


    } else if (this.document) {

      this.isCheckMatchPatners = true;

      this.globalServices.showSpinner();

      let formData = new FormData();

      formData.append('file', this.document);

      this.globalServices.showSpinner();

      this.brandFactoryConnectionService.uploadExcelMatchFactories(formData).subscribe((response) => {

        if (response) {

          if (response['status'] === 'SUCCESS') {
            this.document = null;
            this.fileUploadVariable.nativeElement.value = '';

            this.globalServices.hideSpinner();
            this.matchResultList = response['matchResult']
            this.uploadFactoryListDataSource = new MatTableDataSource(this.matchResultList);
            this.toastService.success(this.alertMsgs['FILE_UPLOAD_SUCCESS_ALERT']);

          } else {
            this.document = null;
            this.fileUploadVariable.nativeElement.value = '';
            this.toastService.error(this.alertMsgs['UNKNOWN_ERROR_ALERT']);
          }

          this.globalServices.hideSpinner();
        }
      },
        (err) => {
          this.document = null;
          this.fileUploadVariable.nativeElement.value = '';
          this.globalServices.hideSpinner();
          this.toastService.error(this.alertMsgs['UNKNOWN_ERROR_ALERT']);

        });
    }
  }

  onSelectedDelete() {
    let dataIn = this.uploadFactoryListDataSource.data;
    let checkedData = dataIn.filter(d => d.checked);
    if (checkedData == null || checkedData.length == 0) {
      this.toastService.warn(this.alertMsgs['UNSELECTED_ITEM_FOR_DELETION_ALERT']);
      return;
    }

    let nonCheckedRecord = dataIn.filter(d => !d.checked);

    // If delete all records, then uncheck "select All" checkbox
    if (nonCheckedRecord == null || nonCheckedRecord.length <= 0) {
      this.matchedAllSelect = false
    }

    this.uploadFactoryListDataSource = new MatTableDataSource(nonCheckedRecord);

  }

  addMultipleBrandConnection() {
    let checkedData = this.uploadFactoryListDataSource.data.filter(d => d.checked == true)
    if (checkedData == null || checkedData.length == 0) {
      this.toastService.error(this.alertMsgs['UNSELECTED_FACTORY_FOR_CONNECTION_ALERT'])
      return
    }

    if (checkedData.find(d => d.requestTo == null || d.requestTo == undefined)) {
      this.toastService.error(this.alertMsgs['UNMATCHED_FACTORY_FOR_CONNECTION_ALERT'])
      return
    }

    this.globalServices.showSpinner();
    this.brandFactoryConnectionService.addMultipleConnection({ data: checkedData }).subscribe(
      (response) => {
        if (response) {

          if (response['status'] === 'SUCCESS') {

            this.onSelectedDelete()
            // this.countBrandConnectionRequest()
            this.toastService.success(this.alertMsgs['CONNECTION_SUCCESS_ALERT'])
            this.brandFactoryConnectionService.commonSubject$.next({ loadLatestConnection: true })
          }
          else {
            this.toastService.error(this.alertMsgs['UNKNOWN_ERROR_ALERT'])
          }
        }
        this.globalServices.hideSpinner();
      },
      (error) => {
        this.globalServices.hideSpinner();

      }
    );
  }


  downloadExcelWorkspace() {

    this.globalServices.showSpinner()
    let downloadFile = 'BRAND_MULTI_CONNECTION_UPLOAD_TEMPLATE.xlsx';

    this.brandFactoryConnectionService.downloadOrgDataInExcel(downloadFile).subscribe(
      (res) => {
        let blob = new Blob([res], { type: 'application/application/octet-stream' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let d = new Date();
        link.download = downloadFile + '.xlsx'
        link.click();
        this.globalServices.hideSpinner();
      },
      (error) => {
        this.globalServices.hideSpinner()
        if (error['status'] == '404' || error['status'] == '500' || error['status'] == '401') {

        }

      }
    );
  }


  // onStatusFilterChnage(status) {
  //   if (status != this.statusFilter) {
  //     this.statusFilter = status
  //     this.countBrandConnectionRequest()
  //   }
  // }


}

